import list from './list';
import { isSuperAdmin, isAdmin } from 'utils';

export default (permissions) => {
  // Super Admins and Admins only
  const isVisible = isSuperAdmin(permissions) || isAdmin(permissions);

  return {
    name: 'user',
    list: isVisible ? list : null,
    icon: 'user',
    options: {
      menuIndex: 8,
      isHidden: !isVisible,
    },
  };
};
